export default "__VITE_ASSET__B7CLurS6__"